import styled from "styled-components";
import Threshold from "constants/threshold";

export const Participants = styled.div`
display: grid;
justify-content: center;
grid-template-columns: repeat(auto-fill, 180px);
max-width: 720px;
margin: 0 auto 15px;

@media (min-width: ${Threshold.tablet}) {
  max-width: 1110px;
  grid-template-columns: repeat(auto-fill, 277px);
  margin-bottom: 20px;
}
`;
